var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"ma-3",staticStyle:{"transition":"all 0.5s ease"},attrs:{"app":"","color":_vm.$store.state.dynamicColors.navBarColor,"flat":"","height":"100","align":"top","dark":""}},[_c('v-spacer'),_c('sign-up-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }